$(document).ready(function () {
    if ($(".en-promocion").length) {
        $(".en-promocion").fadeIn();
        $(".en-promocion").on("click", function () {
            $(this).fadeOut(function () {
                $(this).remove();
            });
        });
    }
});

$(".cerrar-promo").on('click', function (e) {
    e.preventDefault();
    $("#en-promocion-getnet").fadeOut();
});